import React from "react";
import { seasonEpisodeDisplay } from "../../../helpers";
import Season from "./Season";
import Episode from "./Episode";
import Tv from "./Main";
import { Route } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Switch } from "react-router-dom";
import moment from "moment";

class TvShow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      episode: {}
    };
  }

  render() {
    return (
      <React.Fragment>
        {this.state.episode && (
          <div className="text-xl cursor-default truncate mb-4">
            {this.state.episode.subtitle && (
              <div className="text-grey-darker leading-normal mb-2">
                <span className="text-sm text-grey-dark py-1 px-4 rounded border border-grey-light">
                  {seasonEpisodeDisplay(this.state.episode)}
                </span>
                &nbsp;{this.state.episode.subtitle}
                {this.state.episode.air_date && (
                  <span className="text-sm text-grey-dark">
                    &nbsp;({moment(this.state.episode.air_date).fromNow()})
                  </span>
                )}
              </div>
            )}
          </div>
        )}

        <TransitionGroup>
          <CSSTransition
            key={this.props.location.key}
            classNames="fade"
            timeout={300}
          >
            <Switch location={this.props.location}>
              <Route
                exact
                path={this.props.match.path}
                render={() => <Tv media={this.state.media} {...this.props} />}
              />
              <Route
                exact
                path={`${this.props.match.path}/season/:season`}
                component={Season}
              />
              <Route
                exact
                path={`${
                  this.props.match.path
                }/season/:season/episode/:episode`}
                render={props => (
                  <Episode
                    episode={episode => this.setState({ episode })}
                    {...props}
                  />
                )}
              />
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      </React.Fragment>
    );
  }
}

export default TvShow;



// WEBPACK FOOTER //
// ./src/components/Media/TvShow/TvShow.js